import { Injectable } from "@angular/core";
import { ToastrService } from "ngx-toastr";

@Injectable({ providedIn: "root" })
export class ToasterService {
    constructor(private readonly toastr: ToastrService) {}

    pop(type: "success" | "error" | "warning" | "info", title?: string, body?: string): void {
        const msg = body || title;
        const t = body ? title : undefined;
        switch (type) {
            case "success":
                this.toastr.success(msg, t);
                break;
            case "error":
                this.toastr.error(msg, t);
                break;
            case "warning":
                this.toastr.warning(msg, t);
                break;
            case "info":
                this.toastr.info(msg, t);
                break;
        }
    }
}
